<div class="jbm-state-dropdown">
   <label for="stateDropdown" class="float-start">{{'project.state'|translate}}:</label>
   <div ngbDropdown>
      <button type="button" class="btn btn-light float-start" id="stateDropdown" ngbDropdownToggle>
         <span *ngIf="!id">{{'ui.all'|translate}}</span>
         <span *ngIf="id">{{projectstate.description}}</span>
      </button>
      <div ngbDropdownMenu aria-labelledby="stateDropdown">
         <button type="button" *ngIf="id" ngbDropdownItem (click)="setProjectstate(0)">
            <span class="badge badge-pill bg-white text-dark">{{'ui.all'|translate}}</span>
         </button>
         <div *ngFor="let ps of projectstates">
            <button type="button" *ngIf="!(ps.id==id)" ngbDropdownItem (click)="setProjectstate(ps.id)">
               <span class="badge badge-pill" style="background-color: {{ps.color}}; color:{{ps.text_color}}">
                  {{ps.description}}
               </span>
            </button>
         </div>
      </div>
   </div>
</div>
